import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './styles/tailwind.css';
import './App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

// Verificar si la página fue pre-renderizada
if (rootElement.hasChildNodes()) {
  // Si tiene contenido, usar hydrate para preservar el HTML pre-renderizado
  hydrateRoot(rootElement, 
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Si no tiene contenido, usar render normal
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
